import React, { Fragment } from 'react';
import { ContactEntry } from './ContactEntry';

export const ContactEntries = ({ contacts, handleDelete, handleEdit }) => {
   
    const renderContacts = () => {
        const contactsRendered = contacts.map(contact => {
            return <ContactEntry key={contact.contactId} contact={contact} handleDelete={handleDelete} handleEdit={handleEdit}/>
        });
        
        return <Fragment>
                {contactsRendered}
            </Fragment>;
    }

    return (
        <div>
            <table className="table table-striped table-bordered my-2">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Mobile Phone Number</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {renderContacts()}
                </tbody>
            </table>           
        </div>
    )
}